/////BOOTSTRAP/////
require ('bootstrap');

/////JQUERY/////
window.$ = window.jQuery = require('jquery');

/////SWEETALERT2/////
import swal from 'sweetalert2';
window.swal = swal

/////POPPER/////
require('popper.js');

/////SWITCHERY/////
window.Switchery = require('switchery');

/////SPARKLINE/////
require('sparkline');

/////TOASTER/////
window.toastr = require('toastr');

require('tableheadfixer');

require('summernote');
require('summernote/dist/lang/summernote-fr-FR.min');

//Import here the specific librairies for backoffice
import validate from 'jquery-validation';
import 'jquery-validation/dist/localization/messages_fr.js';

require('./includes/hegyd/waves');
require('./includes/hegyd/sidebarmenu');
require('./includes/hegyd/eliateadmin');
require('./includes/hegyd/leave');

require('./includes/theme/theme')
import './includes/theme/perfect-scrollbar.jquery.min'
import './includes/theme/modernizr-object-fit'

const Kernel = require('./utils/Kernel');
window.Kernel = new Kernel();

window.Kernel.registerComponent('Ouvrage', require('./components/Ouvrage').default);
window.Kernel.registerComponent('AcceptCGV', require('./components/AcceptCGV').default);

window.addEventListener("DOMContentLoaded",() => {
    window.Kernel.mountComponents($('html'));
});

